/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxPersist = require('redux-persist');

exports.default = _reduxPersist.persistStore; // flow



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-offline/lib/defaults/persist.js
// module id = 977
// module chunks = 76